class Header extends HTMLElement {
  constructor() {
    super();
    this.scrollPosition = 0;
    this.initSticky = this.initSticky.bind(this);
    this.megamenu = document.querySelector('megamenu-element');
    this.megamenuInner =
      this.megamenu?.querySelector('[data-inner]') || this.megamenu;
    this.mobileBreakpoint = '(max-width: 989px)';
  }

  connectedCallback() {
    this.navItems = this.querySelectorAll('[data-nav-item]');

    window.addEventListener('load', this.initSticky);
    window.addEventListener('scroll', this.initSticky);

    if (this.megamenu && this.megamenuInner) {
      this.navItems.forEach((navItem) => {
        navItem.addEventListener(
          'mouseenter',
          this.handleNavItemMouseEnter.bind(this, navItem),
        );
        navItem.addEventListener(
          'mouseleave',
          this.handleNavItemMouseLeave.bind(this, navItem),
        );
        navItem.addEventListener('click', (event) => {
          event.preventDefault();
        });
      });

      this.megamenuInner.addEventListener(
        'mouseenter',
        this.handleMegamenuMouseEnter.bind(this),
      );
      this.megamenuInner.addEventListener(
        'mouseleave',
        this.handleMegamenuMouseLeave.bind(this),
      );
    }
  }

  handleNavItemMouseEnter(navItem) {
    const megamenuTabButtonTarget = this.megamenu.querySelector(
      `[data-tab-button][data-handle="${navItem.dataset.navHandle}"]`,
    );
    const megamenuTabTarget = this.megamenu.querySelector(
      `[data-tab-id="${megamenuTabButtonTarget.dataset.tagetTabId}"]`,
    );

    if (!megamenuTabButtonTarget || !megamenuTabTarget) {
      return;
    }

    this.updateNavItemsActiveState(navItem.dataset.navHandle);

    this.megamenu.updateNavigationActiveState(megamenuTabButtonTarget);
    this.megamenu.changeTab(megamenuTabTarget);

    this.megamenu.open();
  }

  handleNavItemMouseLeave(navItem, event) {
    this.lastActiveNavItem = navItem;

    navItem.classList.remove('is-active');

    this.megamenu.close();
  }

  handleMegamenuMouseEnter() {
    const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

    if (isMobileDevices) {
      return;
    }

    if (this.lastActiveNavItem) {
      this.updateNavItemsActiveState(this.lastActiveNavItem.dataset.navHandle);

      const megamenuTabButtonTarget = this.megamenu.querySelector(
        `[data-tab-button][data-handle="${this.lastActiveNavItem.dataset.navHandle}"]`,
      );
      const megamenuTabTarget = this.megamenu.querySelector(
        `[data-tab-id="${megamenuTabButtonTarget.dataset.tagetTabId}"]`,
      );

      if (!megamenuTabButtonTarget || !megamenuTabTarget) {
        return;
      }
    }

    this.megamenu.open();
  }

  handleMegamenuMouseLeave() {
    const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

    if (isMobileDevices) {
      return;
    }

    if (this.lastActiveNavItem) {
      this.lastActiveNavItem.classList.remove('is-active');
    }

    this.megamenu.close();
  }

  updateNavItemsActiveState(targetItem) {
    this.navItems.forEach((navItem) => {
      navItem.classList.toggle(
        'is-active',
        navItem.dataset.navHandle === targetItem,
      );
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  initSticky() {
    const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

    if (isMobileDevices && !document.body.classList.contains('is-locked')) {
      this.scrollPosition = Math.round(window.scrollY);
    } else if (!isMobileDevices) {
      this.scrollPosition = Math.round(window.scrollY);
    }

    const headerWrapper = this.closest('.header-wrapper') || this;
    const styleObject = window.getComputedStyle(headerWrapper);
    const topPosition = parseInt(styleObject.top);

    this.toggleSticky(
      topPosition ==
        this.closest('.header-wrapper').offsetTop - this.scrollPosition,
    );
  }

  toggleSticky(flag) {
    this.classList.toggle('is-fixed', flag);
  }
}

customElements.define('section-header', Header);
